import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

export interface IViewAs {
  userId: string;
  refreshMenu: boolean
}

interface IHeaderInitialState {
  viewAs: IViewAs;
  dealQueueLength: number;
  leadQueueLength: number;
}

const initialState: IHeaderInitialState = {
  viewAs: {
    userId: '',
    refreshMenu: false
  },
  dealQueueLength: 0,
  leadQueueLength: 0,
};

export const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    viewAsUserIdAction: (state, action: PayloadAction<IViewAs>) => {
      state.viewAs = action.payload;
    },
    dealQueueCount: (state, action: PayloadAction<number>) => {
      state.dealQueueLength = action.payload;
    },
    leadQueueCount: (state, action: PayloadAction<number>) => {
      state.leadQueueLength = action.payload;
    },
  }
});

export const { viewAsUserIdAction, dealQueueCount, leadQueueCount } = headerSlice.actions;

export const selectViewAsUserId = (state: RootState) => state.header.viewAs;
export const getDealQueueCount = (state: RootState) => state.header.dealQueueLength;
export const getLeadQueueCount = (state: RootState) => state.header.leadQueueLength;
